const launchDarklyClientSideId = '6570b08eba88bb1077af4c88'
const launchDarklyOptions = { streaming: false }

const pagesThatDoNotNeedAuth = ['/register', '/recoverPasswordEmail', '/recoverPasswordEmail/confirmation', '/changePassword']

export { launchDarklyClientSideId, launchDarklyOptions, pagesThatDoNotNeedAuth }
